export default "__VITE_ASSET__CTz8debQ__"